<template>
  <div class=" is-fullwidth">
    <section class="main-content columns is-fullheight">
        <div class="column is-2 sidebar-container"  >
                <div class="  is-fullheight sticky-sidebar" >
     <aside class="menu column  aside   is-fullheight" >
        <form action="">
<h3 class="title is-size-5">Makeup Location</h3>



<div class="field mb-5">
                          <div class="control">
                            <select class="select input" @change="getOrders()" v-model="location_id">
    <option value="">All Locations</option>
    <option :value="row.id" v-for="row in locations" :key="row.id">{{ row.name}}</option>
    
</select>
                             
                          </div>
                      </div>



</form>
     </aside>
     </div>
			 </div>

  
      <div class=" column is-10">
        <div class="section">

          <div class="buttons is-pulled-left">
            <button class="button is-light">{{ filteredOrders.length }} orders</button>
        <button class="button is-light">{{this.total_garment_on_floor}} / {{ this.total_garments }} On Floor</button>
        <button class="button is-light">{{this.total_garment_off_floor}} / {{ this.total_garments }} Off Floor</button>
          </div>
    <div class="">
      <button class="button is-warning is-pulled-right mb-2" @click="exportXLS()">Export to Excel</button>
    </div>
    
    <div class="notification is-info" v-if="loading == true">Loading orders ...</div>
    
    <table class="table is-hoverable is-fullwidth is-size-7" id="orderstable" v-if="loading == false">
    	<thead>
    		<tr>
        <th>PO Number</th>
   	 		<th>Customer</th>
          <th>Garment</th>
          <th></th>
          <th>Extras</th>
          <th>Makeup</th>
          <th @click="updateSortOrder('orderdate')" style="cursor:pointer">Ordered
            <span v-if="order_by === 'orderdate DESC'">&#8595;</span>
            <span v-if="order_by === 'orderdate ASC'">&#8593;</span>
          </th>
          <th @click="updateSortOrder('deliverydate')" style="cursor:pointer">Required
            <span v-if="order_by === 'deliverydate DESC'">&#8595;</span>
            <span v-if="order_by === 'deliverydate ASC'">&#8593;</span>
          </th>
          <th>Qty</th>
          <th>On Floor</th>
          <th>Off Floor</th>
        </tr>
        </thead>
    	<tbody      >
            <tr v-for="order in filteredOrders" v-bind:key="order.orderID">
               <td ><a :href="'/makeup/view-order?ponumber=' + order.ponumber" target="_blank">{{order.ponumber}}</a></td>
          <td>{{order.clientname}}</td>
          <td>{{order.garmentname}}</td>
          <td>
            <span v-if="order.fully_printed==1">F/P</span>
              <span v-if="order.part_printed==1">P/P</span>
                <span v-if="order.cut_sew==1">C/S</span>

          </td>
          <td>
            <OrderExtras :order="order"/>
          </td>
          <td>{{ order.makeup_location_name}}</td>
          <td>{{order.orderdate}}</td>
          <td>{{order.deliverydate}}</td>
          <td>{{ order.total_qty }}</td>
          <td><div class="tag" :class="{'is-warning' : order.on_factory_floor_started == 1 && order.on_factory_floor_finished == 0, 'is-success' : order.on_factory_floor_finished == 1}">On Floor - {{  order.on_floor_completed_qty }}</div></td>
          <td><div class="tag" :class="{'is-warning' : order.off_factory_floor_started == 1 && order.off_factory_floor_finished == 0, 'is-success' : order.off_factory_floor_finished == 1}">Off Floor - {{  order.off_floor_completed_qty }}</div></td> 
			</tr>
    	</tbody>
    </table>

    <table class="table is-hoverable is-fullwidth is-size-7" id="orderstable_excel" style="display:none" >
    	<thead>
    		<tr>
        <th>PO Number</th>
   	 		<th>Customer</th>
          <th>Garment</th>
          <th>Embroidery</th>
          <th>Silicon</th>
          <th>Embossing</th>
          <th>Knitted Trim</th>
          <th>DTF</th>
          <th>GPS</th>
          <th>Makeup</th>
          <th >Ordered</th>
          <th >Required</th>
          <th>Qty</th>
          <th>On Floor</th>
          <th>Off Floor</th>
        </tr>
        </thead>
    	<tbody >     
            <tr v-for="order in filteredOrders" v-bind:key="order.orderID">
               <td >{{order.ponumber}}</td>
          <td>{{order.clientname}}</td>
          <td>{{order.garmentname}}</td>
          
          <td>
            <span v-if="(order.requires_embroidery==1 || order.order_embroidery==1) && order.embroidery_complete == 0">Required</span>
            <span v-if="(order.requires_embroidery==1 || order.order_embroidery==1) && order.embroidery_complete == 1">Completed</span>
          </td>
          <td>
            <span v-if="order.requires_silicon_stripes==1  && order.silicon_complete == 0">Required</span>
            <span v-if="order.requires_silicon_stripes==1  && order.silicon_complete == 1">Completed</span>
          </td>
          <td>
            <span v-if="order.requires_embossing==1">Required</span>
          </td>
          <td>
            <span v-if="order.requires_knitted_trim==1  && order.knitted_trim_complete == 0">Required</span>
            <span v-if="order.requires_knitted_trim==1  && order.knitted_trim_complete == 1">Completed</span>
          </td>
          <td>
            <span v-if="order.requires_dtf==1">Required</span>
          </td>
          <td>
            <span v-if="order.requires_gps_pockets==1">Required</span>
          </td>
          
          <td>{{ order.makeup_location_name}}</td>
          <td>{{order.orderdate_raw}}</td>
          <td>{{order.deliverydate_raw}}</td>
          <td>{{ order.total_qty }}</td>
          <td><span v-if="order.on_factory_floor_started == 1 && order.on_factory_floor_finished == 0">Started</span><span v-if="order.on_factory_floor_finished == 1">Completed</span></td>
          <td><span v-if="order.off_factory_floor_started == 1 && order.off_factory_floor_finished == 0">Started</span><span v-if="order.off_factory_floor_finished == 1">Completed</span></td>    
			</tr>
    	</tbody>
    </table>
    
    
  </div>
</div>
</section>
  </div>
</template>

<script>
import XLSX from 'xlsx';

import OrderService from '@/services/OrderService.js';
import UtilityService from '@/services/UtilityService.js';

import OrderExtras from '@/components/OrderExtras.vue';

import OrderMixin from "@/mixins/OrderMixin.js";

export default {
  components: {
    OrderExtras
  },
  mixins: [OrderMixin],
  data() {
    return {
       errors: [],
      orders: [],
      showModal: false,
      selectedOrderID: 0,
      working :false,
      loading: true,
      ASP_URL : process.env.VUE_APP_ASP_URL,
      cutting_rooms: [],
      locations: [],
      order_by: 'deliverydate ASC',
      location_id: '',
      limit:''
    }
  },
   methods: {
    exportXLS() {
		 //alert("hi")
		 var wb = XLSX.utils.table_to_book(document.getElementById('orderstable_excel'), {sheet:"Sheet JS"});
		 XLSX.writeFile(wb, 'Offshore_Orders.xlsx')

	 },
      async getOrders() {
        this.loading=true
        //OrderService.getCutSewMakeupInProgressOrders(this.accessToken, this.limit, this.order_by, '', 1, 1) // Last 2 fields are cutting complete, ready for makeup set
        OrderService.getOffShoreMakeupInProgressOrders(this.accessToken, this.limit, this.order_by, this.location_id)
        .then(
          (orders => {
            this.$set(this, "orders", orders);
            this.loading=false
          }).bind(this)
        );
      },
       updateMarker(order)
      {
            order.marker_received = 1
            
      },    
    
    async getRanges() {
        UtilityService.getSimpleApiData(this.accessToken, "ranges").then(
               response => this.ranges = response 
            );
      },
      async getCuttingRooms() {
        UtilityService.getSimpleApiData(this.accessToken, "locations?cutting=1").then(
               response => this.cutting_rooms = response 
            );
      },
      async getLocations() {
        UtilityService.getSimpleApiData(this.accessToken, "locations?offshore=1&makeup=1").then(
               response => this.locations = response 
            );
      },
      
    
  },
  computed : {
      filteredOrders: function () {
       
        /*let filteredOrders =  this.orders.filter(function(u) {
            if(  u.in_progress == 0) 
            {
              return 1
            }
          })*/
          let filteredOrders = this.orders

          return filteredOrders
       
     },
     total_garments: function () {
        return this.filteredOrders.reduce((total, order) => total + order.total_qty, 0);
     },
     total_garment_on_floor: function () {
        return this.filteredOrders.reduce((total, order) => total + order.on_floor_completed_qty, 0);
     },
     total_garment_off_floor: function () {
        return this.filteredOrders.reduce((total, order) => total + order.off_floor_completed_qty, 0);
     }
  },

  // Fetches posts when the component is created.
  created() {
     this.getAccessToken()
        .then(() => { 
           this.getOrders();
           //this.getCuttingRooms();
           this.getLocations();
        });
  },
 
  mounted() {
    
      
  },
  watch: {
    'cutting_location_id'() {
      this.orders = []
      //localStorage.printing_location_id = this.selected_location_id
      this.getOrders();
    },
    
  }
}


</script>

